import { BrowserRouter } from "react-router-dom";
import { Layout } from "./components/Layout";
import { MotionProvider } from "./components/motion/MotionProvider";
import { AuthProvider } from "./context/AuthContext";

export function App() {
  return (
    <AuthProvider>
      <MotionProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </MotionProvider>
    </AuthProvider>
  );
}
